export function SentryErrorFallback() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6">
      <div className="max-w-md text-center">
        <p className="text-[#1A1A1A] font-semibold font-poppins mb-2">Something went wrong</p>
        <p className="text-[#555555] text-sm mb-6">
          An unexpected error occurred. You can reload the page or try again in a moment.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-xl bg-[#121212] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#2A2A2A] transition-colors"
        >
          Reload page
        </button>
      </div>
    </div>
  );
}
